import { FulfilmentProcess } from '@/models/fulfilment-process-model';
import { Event } from './event';

export class FulfilmentProcessAcquiredEvent extends Event<FulfilmentProcess> {}
